import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogConfigInterface} from 'appShared/components/dialog';
import {AddPlatformFrontendForm} from 'appEntries/panel/forms';
import {ApiError, SesService} from '@spa/api';
import {PlatformFrontendFormErrorStatesEnum} from 'appEntries/panel/enums';
import {PlatformFrontendAddMessages} from 'appAssets/messages';
import {AlertsService, CurrencyService} from 'appShared/services';
import {TradingPlatformInfoInterface} from '@spa/api/lib/interfaces';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';

@Component({
    selector: 'app-platform-frontend-add',
    templateUrl: './platform-frontend-add.component.html',
    styleUrls: ['./platform-frontend-add.component.scss']
})
export class PlatformFrontendAddComponent extends PanelBaseMarketDataFormDialogComponent<PlatformFrontendAddComponent> {

    public tradingPlatforms: TradingPlatformInfoInterface[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            tradingPlatforms: TradingPlatformInfoInterface[]
        },
        private readonly sesService: SesService,
        private readonly currencyService: CurrencyService,
        protected alertsService: AlertsService,
        public dialogRef: MatDialogRef<PlatformFrontendAddComponent>,
    ) {
        super(dialogRef, alertsService);
        this.config = data.config;
        this.tradingPlatforms = data.tradingPlatforms;
    }

    initForm(): void {
        this.form = new AddPlatformFrontendForm(this.sesService, this.currencyService, this.tradingPlatforms);
        this.form.initForm();
    }

    getSuccessFormMessage(): string {
        return PlatformFrontendAddMessages.PlatformFrontendCreationSucceed.message;
    }

    getErrorMessageByApiError(error: ApiError): string {
        if (error.status === PlatformFrontendFormErrorStatesEnum.CreatePlatformFrontendFailed) {
            return PlatformFrontendAddMessages.PlatformFrontendCreationFailed.message;

        }

        return PlatformFrontendAddMessages.UnknownError.message;
    }
}
